module.exports = __webpack_public_path__ + "img/logo.2960f9eb.svg";